import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-social-links',
  templateUrl: './add-social-links.component.html',
  styleUrls: ['./add-social-links.component.scss']
})
export class AddSocialLinksComponent implements OnInit {
formData: any = {
  name: '',
  url: '',
  image: null
};
urlError: string | null = null;

// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute, private translate: TranslateService
    ) { }
  
    ngOnInit(): void {
  
    }



    cancel(): void {
      this.router.navigate(['/social-links']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

normalizeUrl() {
  if (!this.formData.url) {
    this.urlError = null;
    return;
  }

  // add https:// automatically
  if (
    !this.formData.url.startsWith('http://') &&
    !this.formData.url.startsWith('https://')
  ) {
    this.formData.url = 'https://' + this.formData.url;
  }

  // validate after normalize
  this.urlError = this.isValidUrl(this.formData.url)
    ? null
    : 'The url field must be a valid URL.';
}

isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}


onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.image = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
}



submitForm(): void {
  const formDataToSend = new FormData();
  this.normalizeUrl();

  formDataToSend.append('name', this.formData.name);
  formDataToSend.append('url', this.formData.url);

  if (!this.isValidUrl(this.formData.url)) {
    return; // stop submit
  }
if (this.formData.image) {
  formDataToSend.append('image', this.formData.image);
} else {
this.translate.get([
  'MENU.DASHBOARD.ERROR',
  'MENU.DASHBOARD.SELECT_IMAGE',
  'MENU.DASHBOARD.OK'
]).subscribe(trans => {
  Swal.fire({
    title: trans['MENU.DASHBOARD.ERROR'],
    text: trans['MENU.DASHBOARD.SELECT_IMAGE'],
    icon: 'error',
    confirmButtonText: trans['MENU.DASHBOARD.OK']
  });
});
    return;
}

  const id = this.route.snapshot.paramMap.get('id');

  this.apisService.addSocialLinks(+id, formDataToSend).subscribe({
    next: (res) => {
      //  this.translate.get([
      //   'MENU.DASHBOARD.SUCCESS',
      //   'MENU.DASHBOARD.USER_SAVED'
      // ]).subscribe(trans => {
      //   Swal.fire(trans['MENU.DASHBOARD.SUCCESS'], trans['MENU.DASHBOARD.USER_SAVED'], 'success');
      // });
      // this.router.navigate(['/fake-user']);
      this.router.navigate(['/social-links'], { queryParams: { success: 'true' } });

    },
    error: (err) => {
      console.error('Upload error:', err);
      this.translate.get([
        'MENU.DASHBOARD.ERROR',
        'MENU.DASHBOARD.FIX_ERRORS'
      ]).subscribe(trans => {
        Swal.fire(trans['MENU.DASHBOARD.ERROR'], trans['MENU.DASHBOARD.FIX_ERRORS'], 'error');
      });
    }
  });
}



}
